export default function settings() {
  return {
    settings_preloadall: 'on',
    settings_dummy_items_nr: 10,
    view_responsive_breakpointForPhone: 550,
    grid: 'dzs-layout--5-cols',
    address_query_remove_add_to_cart_in_shop_page: 'on',
    input: ''
  }
}